export const contactsData = {
    email: 'officialsiddharthbisht @gmail.com',
    phone: '+91 8077305268',
    address: 'Remote - Nainital Uttrakhand India',

    sheetAPI: 'https://script.google.com/macros/s/AKfycbxe0K4ko-HYfLe55il1n6arLhDrSakkxYNpnQgMCmTPiJoG9Ag5O-CG8fVJViQrFzfoVg/exec'
}